<template>
    <div class="w-1/3 h-auto px-3 mb-6">
        <div class="flex flex-col shadow-md bg-white rounded p-4 h-full">
            <div class="flex flex-wrap items-center">
                <div
                    class="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center text-gray-400"
                >
                    <font-awesome
                        icon="folder"
                        class="fa-2x"
                        :class="hasManager ? 'text-'+manager.color : ''"
                    ></font-awesome>
                </div>
                <div class="ml-4">
                    <h2 class="text-lg">{{ project.name }}</h2>
                    <h4 class="text-sm mt-1 text-gray-400">{{ project.slogan || "Bez pod-nadpisu" }}</h4>
                </div>
                <div class="ml-auto">
                    <md-button
                        :to="{ name: 'projects.detail', params: { projectId: project.id } }"
                        class="md-icon-button  md-accent">
                        <md-icon>arrow_forward</md-icon>
                    </md-button>
                </div>
            </div>
            <!-- y -->
            <div class="flex flex-wrap items-start mt-6 -mx-4">
                <div class="w-1/3 px-4">
                    <span class="mb-1 block text-gray-500">Stav</span>
                    <div
                        class="rounded text-center font-bold text-sm py-1"
                        :class="'bg-'+project.status.color+'-100 ' + 'text-'+project.status.color+'-400'"
                    >{{ project.status.name }}</div>
                </div>
                <div class="w-1/3 px-4">
                    <span class="mb-1 block text-gray-500">Dátum odovz.</span>
                    <div
                        class="rounded text-center font-bold text-sm py-1 bg-gray-100 text-gray-500"
                    >{{ getFormattedDate(project.due_date_timestamp, "DD.MM.YYYY") || "Neurčené" }}</div>
                </div>
                <div class="w-1/3 px-4">
                    <span class="mb-1 block text-gray-500">Dátum vzniku</span>
                    <div
                        class="rounded text-center font-bold text-sm py-1 bg-gray-100 text-gray-500"
                    >{{ getFormattedDate(project.created_at, "DD.MM.YYYY") }}</div>
                </div>
                <div class="w-1/3 px-4">
                    <span class="mb-1 block text-gray-500 mt-3">Manažér</span>
                    <div
                        class="rounded font-bold text-sm py-1 text-gray-500 bg-gray-100 text-center"
                        :class="'text-'+(hasManager ? manager.color : 'gray-300')"
                    >{{ hasManager ? shortifyName(manager.name) : "Bez man."}}</div>
                </div>
                <div class="w-1/3 px-4">
                    <span class="block text-gray-500 mt-3">Členovia</span>
                    <div class="flex w-full">
                        <span
                            class="rounded text-center px-4 font-bold mt-1 text-sm py-1 bg-gray-100 text-gray-500 w-full"
                            v-if="project.members.length === 0">
                            Bez členov
                        </span>
                        <span
                            v-for="(member, index) in project.members.slice(0, 4)"
                            :key="'pmember'+member.id"
                            class="-mt-1 flex items-center justify-center bg-gray-300 rounded-full w-10 h-10 border-4 border-white text-xs text-white"
                            :class="'bg-'+member.color+' '+ (index === 0 ? '' : '-ml-2')">
                            <md-tooltip md-direction="bottom">{{ member.name }}</md-tooltip>
                            {{ getInicials(member) }}
                        </span>
                        <span
                            v-if="project.members.length > 4"
                            class="-mt-1 text-white text-xs flex items-center justify-center bg-gray-500 rounded-full w-10 h-10 border-4 border-white -ml-2"
                        >+{{ project.members.length - 4 }}</span>
                    </div>
                </div>

            </div>
            <!-- desc -->
            <div class="flex my-6">
                <p class="text-gray-400 text-sm">{{ project.description || "Bez popisu" }}</p>
            </div>
            <!-- foot -->
        </div>
    </div>
</template>

<script>
import { shortifyName, getInicials, formatTotal } from "../../utils";

export default {
    name: "ProjectItemMini",
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    
    data: () => ({
        managers: []
    }),

    computed: {
        hasManager() {
            return this.managers.length > 0;
        },

        manager() {
            return this.managers[0];
        },

        totalTime() {
            return formatTotal(this.project.totalTime);
        }
    },
    
    mounted() {
        this.managers = this.project.members.filter(member => {
            return member.type.id === 2;
        })
    },

    methods: {
        getFormattedDate(date, format = "DD.MM.YYYY HH:mm:ss") {
            if (!date) return null;
            return moment.unix(date).format(format);
        },
        
        shortifyName(name) {
            return shortifyName(name);
        },
        
        getInicials(user) {
            return getInicials(user.name, user.image);
        },
    }
};
</script>
